import React, {useEffect, useState} from 'react'
import {Col, Modal, Row} from 'react-bootstrap'
import {createPortal} from 'react-dom'
import closeicon from '../../../../_metronic/images/closeSymbol.svg'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import {
  CREATE_SCRIPT_SETTINGS,
  GET_SCRIPT_SETTINGS,
  UPDATE_SCRIPT_SETTINGS,
} from '../../../../utils/GraphQLAPI'
import {useLazyQuery, useMutation} from '@apollo/client'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import {alert} from '../../../../utils/helper'
import Tooltip from '../../../sharedComponent/CustomTooltip/Tooltip'

const MySwal = withReactContent(Swal)
const modalsRoot = document.getElementById('root-modals') || document.body

type Props = {
  showCreateAppModal: boolean
  handleClose: () => void
  settingsAdded: any
  setSettingsAdded: any
}
const WELCOMEMSGEN =
  'Hello and welcome to TPV Solutions verification system. You have reached an automated recording. To ensure the accuracy of your information, please speak clearly and follow the instructions provided. If you need to repeat any question, simply say Repeat and we will repeat the question for you.'
const WELCOMEMSGES =
  'Hola y bienvenido al sistema de verificación de TPV Solutions. Ha llegado a una grabación automática. Para garantizar la exactitud de su información, hable claramente y siga las instrucciones proporcionadas. Si necesita repetir alguna pregunta, simplemente diga Repetir y le repetiremos la pregunta'
export const defaultSettings = {
  customerResponse: 0,
  questionRepeated: 0,
  contactedTime: 0,
  contactedDays: 0,
  welcomeMessageEn: WELCOMEMSGEN,
  welcomeMessageEs: WELCOMEMSGES,
  autoApprove: false,
  isMixMatch: false,
}

// Need to set these when we click on edit
export const editSettings = {
  customerResponse: 0,
  questionRepeated: 0,
  contactedTime: 0,
  contactedDays: 0,
  welcomeMessageEn: '',
  welcomeMessageEs: '',
  autoApprove: false,
  isMixMatch: false,
}

const filedRequiredTitle = 'The field is required'

const enrollSchema = Yup.object().shape({
  customerResponse: Yup.number().required(filedRequiredTitle),
  questionRepeated: Yup.number().required(filedRequiredTitle),
  contactedTime: Yup.number().required(filedRequiredTitle),
  contactedDays: Yup.number().required(filedRequiredTitle),
})

const ScriptSetting = ({
  showCreateAppModal,
  handleClose,
  settingsAdded,
  setSettingsAdded,
}: Props) => {
  const [editqcData, setEditqcdata] = useState<any>()
  const [method, setMethod] = useState<any>('')

  useEffect(() => {
    if (method === 'create') {
      formik.setValues({...defaultSettings})
    } else if (method === 'edit') {
      formik.setValues({...editqcData})
    }
  }, [showCreateAppModal, editqcData])

  const formik = useFormik({
    initialValues: defaultSettings,
    validationSchema: enrollSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      console.log('values', values)

      if (method === 'create') {
        createScriptSettings({
          variables: {
            createScriptSettingInput: {
              waitingtime: Number(values.customerResponse),
              questionRetry: Number(values.questionRepeated),
              custMaxRetry: Number(values.contactedTime),
              retryDays: Number(values.contactedDays),
              welcomeMessageEN: values.welcomeMessageEn,
              welcomeMessageES: values.welcomeMessageEs,
              autoApprove: values.autoApprove,
              isMixMatch: values.isMixMatch,
            },
          },
        })
      } else if (method === 'edit') {
        updateScriptSettings({
          variables: {
            updateScriptSettingInput: {
              scriptSettingsId: editqcData.id,
              waitingtime: Number(values.customerResponse),
              questionRetry: Number(values.questionRepeated),
              custMaxRetry: Number(values.contactedTime),
              retryDays: Number(values.contactedDays),
              welcomeMessageEN: values.welcomeMessageEn,
              welcomeMessageES: values.welcomeMessageEs,
              autoApprove: values.autoApprove,
              isMixMatch: values.isMixMatch,
            },
          },
        })
      }
    },
  })

  // CREATE
  const [createScriptSettings] = useMutation(CREATE_SCRIPT_SETTINGS, {
    onCompleted: (data) => {
      if (data.createScriptSetting.scriptSettingsId) {
        //data.updateQcUser.id
        const options: any = {
          customClass: {
            popup: 'swal2-border-radius',
          },
          title: 'Script settings added successfully',
          icon: 'success',
          confirmButtonColor: '#3E97FF',
        }
        MySwal.fire(options)
        formik.setValues({...editqcData})
      } else {
        MySwal.fire({
          icon: 'error',
          title: 'Error in creating customer',
        })
      }
      getScriptSettings()
      handleClose()
      formik.setValues({...editqcData})
    },
    onError: (e) => alert(e.message, 'error'),
  })

  // UPDATE
  const [updateScriptSettings] = useMutation(UPDATE_SCRIPT_SETTINGS, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      if (data.updateScriptSetting.scriptSettingsId) {
        //data.updateQcUser.id
        const options: any = {
          customClass: {
            popup: 'swal2-border-radius',
          },
          title: 'Script settings updated successfully',
          icon: 'success',
          confirmButtonColor: '#3E97FF',
        }
        MySwal.fire(options)
        handleClose()
        formik.setValues({...editSettings})
      } else {
        MySwal.fire({
          icon: 'error',
          title: 'Error in creating customer',
        })
      }
      // refetchList()
      getScriptSettings()
      handleClose()
      formik.setValues({...editSettings})
    },
    onError: (e) => alert(e.message, 'error'),
  })

  // GET_SCRIPT
  const [getScriptSettings] = useLazyQuery(GET_SCRIPT_SETTINGS, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      setSettingsAdded(true)
      const tempEditSettings = {
        id: data.getScriptSettings.scriptSettingsId,
        customerResponse: data.getScriptSettings.waitingtime,
        questionRepeated: data.getScriptSettings.questionRetry,
        contactedTime: data.getScriptSettings.custMaxRetry,
        contactedDays: data.getScriptSettings.retryDays,
        welcomeMessageEn: data.getScriptSettings.welcomeMessageEN,
        welcomeMessageEs: data.getScriptSettings.welcomeMessageES,
        autoApprove: data.getScriptSettings.autoApprove,
        isMixMatch: data.getScriptSettings.isMixMatch,
      }
      formik.setValues({...tempEditSettings})
      setEditqcdata(tempEditSettings)
      setMethod('edit')
    },
    onError: ({graphQLErrors}: any) => {
      if (graphQLErrors[0].extensions.code === '422') {
        setSettingsAdded(false)
      }
      setMethod('create')
      console.log('error', graphQLErrors)
    },
  })

  useEffect(() => {
    getScriptSettings()
  }, [])

  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-650px'
      show={showCreateAppModal}
      onHide={handleClose}
      backdrop={true}
    >
      <form noValidate onSubmit={formik.handleSubmit}>
        <div className='modal-header'>
          <h5 className='modal-title fs-3 fw-bold'>Client Setup</h5>
          <div
            className='btn btn-icon btn-sm btn-active-light-primary ms-2'
            data-bs-dismiss='modal'
            aria-label='Close'
          >
            <img src={closeicon} alt='close' onClick={() => handleClose()} />
          </div>
        </div>
        <div className='modal-body' style={{padding: '2.75rem'}}>
          <Row>
            <Col sm={12} md={12} className='mr-0 ml-0 pb-8'>
              <label className='d-flex align-items-center mb-2'>
                <span className='fs-6 fw-semibold lh-23px'>
                  Waiting time for a customer's response
                </span>
              </label>
              <select
                className='form-select form-select-solid'
                aria-label='Select example'
                //   name='customerResponse'
                {...formik.getFieldProps('customerResponse')}
              >
                {' '}
                <option value=''>Select</option>
                <option value='1'>1 sec</option>
                <option value='2'>2 sec</option>
                <option value='3'>3 sec</option>
                <option value='5'>5 sec</option>
                <option value='10'>10 sec</option>
                <option value='15'>15 sec</option>
                <option value='30'>30 sec</option>
              </select>
              {formik.errors.customerResponse && (
                <div className='fv-plugins-message-container'>
                  <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                    {formik.errors.customerResponse}
                  </div>
                </div>
              )}
            </Col>
            <Col sm={12} md={12} className='mr-0 ml-0 pb-8'>
              <label className='d-flex align-items-center mb-2'>
                <span className='fs-6 fw-semibold lh-23px'>
                  Number of times a question needs to be repeated if there is No response
                </span>
              </label>
              <select
                className='form-select form-select-solid'
                aria-label='Select example'
                //   name='questionRepeated'
                {...formik.getFieldProps('questionRepeated')}
              >
                <option value=''>Select</option>
                <option value='1'>1</option>
                <option value='2'>2</option>
                <option value='3'>3</option>
                <option value='4'>4</option>
                <option value='5'>5</option>
              </select>
              {formik.errors.questionRepeated && (
                <div className='fv-plugins-message-container'>
                  <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                    {formik.errors.questionRepeated}
                  </div>
                </div>
              )}
            </Col>
          </Row>
          <Row>
            <label className='d-flex align-items-center mb-2'>
              <span className='fs-6 fw-semibold lh-23px'>
                Customer may be contacted by TPV within a certain number of days
              </span>
            </label>
            <Col sm={6} md={6} className='mr-0 ml-0 pb-5'>
              <select
                className='form-select form-select-solid'
                aria-label='Select example'
                //   name='contactedTime'
                {...formik.getFieldProps('contactedTime')}
              >
                <option value=''>Select time</option>
                <option value='1'>1</option>
                <option value='2'>2</option>
                <option value='3'>3</option>
                <option value='4'>4</option>
                <option value='5'>5</option>
                <option value='6'>6</option>
                <option value='7'>7</option>
                <option value='8'>8</option>
                <option value='9'>9</option>
                <option value='10'>10</option>
              </select>
              {formik.errors.contactedTime && (
                <div className='fv-plugins-message-container'>
                  <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                    {formik.errors.contactedTime}
                  </div>
                </div>
              )}
            </Col>
            <Col sm={6} md={6} className='mr-0 ml-0 pb-5'>
              <select
                className='form-select form-select-solid'
                aria-label='Select example'
                //   name='contactedDays'
                {...formik.getFieldProps('contactedDays')}
              >
                <option value=''>Select day</option>
                <option value='1'>1</option>
                <option value='2'>2</option>
                <option value='3'>3</option>
                <option value='4'>4</option>
                <option value='5'>5</option>
                <option value='6'>6</option>
                <option value='7'>7</option>
                <option value='8'>8</option>
                <option value='9'>9</option>
                <option value='10'>10</option>
              </select>
              {formik.errors.contactedDays && (
                <div className='fv-plugins-message-container'>
                  <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                    {formik.errors.contactedDays}
                  </div>
                </div>
              )}
            </Col>
          </Row>
          <Row>
            <label className='d-flex align-items-center mb-2'>
              <span className='fs-6 fw-semibold lh-23px'>Welcome Message EN</span>
            </label>
            <textarea
              className='form-control form-control-lg form-control-solid resize-none min-h-100px'
              placeholder='Enter Welcome Message EN'
              maxLength={2000}
              {...formik.getFieldProps('welcomeMessageEn')}
              rows={4}
            ></textarea>
          </Row>
          <Row>
            <label className='d-flex align-items-center mb-2 mt-2'>
              <span className='fs-6 fw-semibold lh-23px'>Welcome Message ES</span>
            </label>
            <textarea
              className='form-control form-control-lg form-control-solid resize-none min-h-100px'
              placeholder='Enter Welcome Message ES'
              maxLength={2000}
              {...formik.getFieldProps('welcomeMessageEs')}
              rows={4}
            ></textarea>
          </Row>
          <Row>
            <Col sm={12} md={12} className='mr-0 ml-0 pb-8 mt-4'>
              <label className='d-flex align-items-center mb-2'>
                <>
                  <input
                    type='checkbox'
                    className='form-check-input'
                    {...formik.getFieldProps('autoApprove')}
                    checked={formik.values.autoApprove}
                  />
                  <span className='fs-6 fw-semibold lh-23px ms-4'>Auto Approve TPV's</span>
                </>
              </label>
            </Col>
          </Row>
          <label className='d-flex align-items-center mb-2'>
            <>
              <input
                type='checkbox'
                className='form-check-input'
                {...formik.getFieldProps('isMixMatch')}
                checked={formik.values.isMixMatch}
              />
              <span className='fs-6 fw-semibold lh-23px ms-4'>
                Cross-sell Electric and Gas Product
              </span>
              <Tooltip
                text='Allow agents to offer any Electric and Gas product as a bundle from authorized list. No action required for pre-configured Dual product'
                isLast={true}
              />
            </>
          </label>
        </div>
        <div className='modal-footer'>
          <button
            type='button'
            className='btn btn-light'
            data-bs-dismiss='modal'
            onClick={() => handleClose()}
          >
            Discard
          </button>
          <button type='submit' className='btn btn-primary'>
            {method === 'edit' ? 'Update' : 'Submit'}
          </button>
        </div>
      </form>
    </Modal>,
    modalsRoot
  )
}

export default ScriptSetting
